module.exports = __webpack_public_path__ + "img/biwako.72cf1c00.png";